import { PermissionsService} from '@/modules/permissions/permissions-service';
import Errors from '@/shared/error/errors';
import Message from '@/shared/message/message';
import i18n from '@/shared/plugins/vue-i18n';

// action types
export const ADD_PERMISSIONS_TO_ORGANISATION = 'addPermissionsToOrganisation';
export const FETCH_ORGANISATION = 'fetchOrganisation';
export const FETCH_PERMISSIONS_BY_ORG_SCOPE = 'fetchPermissionsByOrgScope';

// mutation types
export const SET_ORGANISATION = 'setOrganisation';
export const SET_PERMISSIONS = 'setPermissions';

const state = {
    organisation: {},
    permissionsByOrgScope: []
};

const getters = {
    permissionsByOrgScope: (state) => state.permissionsByOrgScope,
    organisation: (state) => state.organisation,
};

const mutations = {
    [SET_PERMISSIONS](state, permissions) {
        state.permissionsByOrgScope = permissions;
    },
    [SET_ORGANISATION](state, organisation) {
        state.organisation = organisation;
    },
};

const actions = {
    [ADD_PERMISSIONS_TO_ORGANISATION](context, { id, permissions }) {
        return new Promise((resolve, reject) => {
            context.commit('shared/activateLoading', 'permissions/addPermissionsToOrganisation', { root: true });
            PermissionsService.addPermissionsToOrganisation(id, permissions)
                .then(() => {
                    Message.success(i18n.t('GENERAL.UPDATED_SUCCESS'));
                    resolve();
                })
                .catch(( error ) => {
                    Errors.handle(error);
                    reject();
                })
                .finally(() => {
                    context.commit('shared/deactivateLoading', 'permissions/addPermissionsToOrganisation', { root: true });
                });
        });

    },
    [FETCH_ORGANISATION](context, id) {
        context.commit('shared/activateLoading', 'permissions/getOrganisation', { root: true });
        return new Promise((resolve, reject) => {
            PermissionsService.fetchOrganisation(id)
            .then(({ data }) => {
                context.commit(SET_ORGANISATION, data);
                resolve(data);
            })
            .catch((error) => {
                Errors.handle(error);
                reject();
            })
            .finally(() => {
                context.commit('shared/deactivateLoading', 'permissions/getOrganisation', { root: true });
            })
        });
    },
    [FETCH_PERMISSIONS_BY_ORG_SCOPE](context) {
        context.commit('shared/activateLoading', 'permissions/getPermissionsByOrgScope', { root: true });
        return new Promise((resolve, reject) => {
            PermissionsService.fetchPermissionsByOrgScope()
            .then(({ data }) => {
                context.commit(SET_PERMISSIONS, data.data);
                resolve(data);
            })
            .catch((error) => {
                Errors.handle(error);
                reject();
            })
            .finally(() => {
                context.commit('shared/deactivateLoading', 'permissions/getPermissionsByOrgScope', { root: true });
            })
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
